import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { config } from "../../../style";

function DisplayTextBox({ title, value, type, sx = {}, prepareData = () => {} }) {
    useEffect(() => {
        prepareData(title, { value, type });
    }, [value, title]);

    return (
        <>
            {!type && (
                <Box sx={{ mb: "10px", ...sx }}>
                    {title && (
                        <Typography variant="subtitle2" fontSize={"12px"} color={config.baseColor} fontWeight={700}>
                            {title}
                        </Typography>
                    )}
                    <Typography
                        component={"p"}
                        variant="body"
                        color={config.grayColor}
                        fontSize={"15px"}
                        lineHeight={"20px"}
                        sx={{ display: "block" }}>
                        {value}
                    </Typography>
                </Box>
            )}
            {type === "link" && (
                <Box sx={{ mb: "10px", ...sx }}>
                    {title && (
                        <Typography variant="subtitle2" fontSize={"12px"} color={config.baseColor} fontWeight={700}>
                            {title}
                        </Typography>
                    )}
                    <Typography
                        component={"a"}
                        variant="body"
                        target="_blank"
                        href={value.startsWith("https") ? value : "https://" + value}
                        color={config.grayColor}
                        fontSize={"15px"}
                        lineHeight={"20px"}
                        sx={{ display: "block" }}>
                        {value}
                    </Typography>
                </Box>
            )}
        </>
    );
}

export default DisplayTextBox;
